import MapElementDataStream from "./MapElementDataStream";

export default class ShapeDataStream extends MapElementDataStream {
    constructor(id, forceAllVisible = false) {
        super(id, forceAllVisible);
    }
}